import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const productQUotaApi = createApi({
  reducerPath: "productQUotaApi",
  baseQuery,
  tagTypes: ["Quota"],

  endpoints: (builder) => ({
    getProductQuotaById: builder.query({
      query: ({id}) => `/export/product/quota/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.exportProductQuotaId,
        }));
      },
      providesTags: ["Quota"],
    }),

    createQuota: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/quota/${id}`,
        method: "PUT",
        body: { productQuota: data },
        headers: {
          "X-Request-Id": `${Date.now()}`,
        },
      }),
      invalidatesTags: ["Quota"],
    }),

    updateQuota: builder.mutation({
      query: ({id,subId,...data}) => ({
        url: `/export/product/quota/${id}/${subId}`,
        method: "PUT",
        body: { productQuota: data },
        headers: {
          "X-Request-Id": `${Date.now()}`,
        },
      }),
      invalidatesTags: ["Quota"],
    }),

    deleteQuota: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/quota/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": `${Date.now()}`,
        },
      }),
      invalidatesTags: ["Quota"],
    }),
  }),
});

export const {
  useCreateQuotaMutation,
  useUpdateQuotaMutation,
  useDeleteQuotaMutation,
  useLazyGetProductQuotaByIdQuery,
} = productQUotaApi;
